// src/agentClient.ts
const AGENT_API = process.env.REACT_APP_AGENT_API_BASE_URL || process.env.VITE_AGENT_API_BASE_URL || "https://jira-backend-362149611676.us-central1.run.app";

export const agentLoginUrl = (idToken: string) => {
  const returnTo = `${window.location.origin}/workspace`;
  return `${AGENT_API}/auth/login?id_token=${encodeURIComponent(idToken)}&return_to=${encodeURIComponent(returnTo)}`;
};

export async function getAgentUser(token: string): Promise<any | null> {
  try {
    console.log(`[AgentClient] Attempting to fetch user session from: ${AGENT_API}/api/me`);
    const res = await fetch(`${AGENT_API}/api/me`, { 
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });

    if (!res.ok) {
      console.warn(`[AgentClient] /api/me returned status: ${res.status}`);
      return null;
    }

    const data = await res.json();
    console.log("[AgentClient] Successfully retrieved user session:", data);
    return data;
  } catch (error) {
    console.error("[AgentClient] Network or CORS error when calling /api/me:", error);
    return null;
  }
}

interface StreamAgentReplyArgs {
  message: string;
  sessionId: string | null;
  token: string;
  onChunk: (text: string) => void;
  onDone?: () => void;
}

// Streams agent replies. Calls onChunk(text) for each piece and onDone() at the end.
export async function streamAgentReply({ message, sessionId, token, onChunk, onDone }: StreamAgentReplyArgs): Promise<string | null> {
  const res = await fetch(`${AGENT_API}/api/chat`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ message, session_id: sessionId }),
  });
  console.log(res)
  if (res.status === 401) {
    const err = new Error("Not signed in") as any;
    err.status = 401;
    throw err;
  }

  const newSessionId = res.headers.get("X-Session-Id");
  const reader = res.body?.getReader();
  if (!reader) {
    if (onDone) onDone();
    return newSessionId;
  }

  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop() || "";

    for (const ev of events) {
      if (!ev.startsWith("data: ")) continue;
      const data = ev.slice(6);
      if (data === "[DONE]") {
        if (onDone) onDone();
        return newSessionId;
      }
      try {
        const { text } = JSON.parse(data);
        if (text) onChunk(text);
      } catch (e) {
        // ignore parse error for incomplete chunks
      }
    }
  }
  if (onDone) onDone();
  return newSessionId;
}
